import { Component, OnInit, AfterViewInit, Input,ViewChild} from '@angular/core';
import * as Highcharts from 'highcharts';
// import { GlobalService } from '../../../services/global.service';
// import { MessageService } from '../../../services/message.service';
// import { GraphService } from '../../../services/graphs.service';
// import { Observable } from 'rxjs';
// import { ConfigModel } from 'src/app/models/graphs.model';
// import { WellsModel } from 'src/app/models/wells.model';
// import { Location, ViewportScroller } from '@angular/common';
// import { filter } from 'rxjs/operators';
// import { Router, Scroll } from '@angular/router';

@Component({
    selector: 'app-ehs-process-safety',
    templateUrl: './processSafety.component.html',
    styleUrls: ['../../home/home.component.scss', './processSafety.Component.scss'],
})
export class ProcessSafetyComponent implements AfterViewInit {
    Highcharts = Highcharts;
    @Input() ehs_CurrentYear: number;
    @Input() ehs_Process_CurrentYearValue;
    @Input() ehs_Process_LastYearValue: number;
    @Input() ehs_Process_Text: string;

    @Input() ehs_Process_Max: number;
    @Input() ehs_Process_Yellow: number;
    @Input() ehs_Process_Orange: number;

    ehsChart: Object;

    constructor() {}        

    ngAfterViewInit(): void {
            setTimeout(() => {
                this.refresh();
        })
    }

    refresh()  {
       const maxValue = (this.ehs_Process_Max);
        let vl: number = parseInt(this.ehs_Process_CurrentYearValue);
        this.ehsChart = {
            credits: {
                enabled: false
            },

            chart: {
                type: 'solidgauge',
                height: '220',
                backgroundColor: "#fff",
                borderWidth: 0,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBackgroundColor:  "#fff",
            },
            exporting: { enabled: false },
            title:{
                text:null
            },
            pane: {
                center: [ "50%", "80%" ],
                size: '150%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                },
            },
        
            tooltip: {
                enabled: false
            },
        
            yAxis: {
                min: 0,
                max:Number(maxValue),
                stops: [
                    [0, '#ffff4d'],
                    [this.ehs_Process_Yellow / this.ehs_Process_Max, '#FFA500'],
                    [this.ehs_Process_Orange / this.ehs_Process_Max, '#DF5353'] // red
                ],
                tickInterval: maxValue/1,
                minorTickLength: 0,
                tickLength: 0,     // 🔸 Hide tick marks               
               minorTickInterval: 200,
                majorTickInterval: 200,
                labels: {
                    y: 16
                },
                tickColor: '#DFDFDF',
                // plotLines: [{ 
                //     color: 'green', 
                //   width: 1, 
                //   value: 13,
                //    zIndex: 10,
                //   dashStyle: 'Dash',
                //   label: {
                //     text: 'Target',
                //     verticalAlign: 'top',
                //        //textAlign: 'left',
                //     y: -5
                //     }
                // }],
            },          

            series: [{
                data: [vl],
                dataLabels: {
                    enabled: false
                }
            }]
        };
        console.log(this.ehsChart);
    }
   
}